import React, { useEffect, useState, useCallback } from "react";
import Layout from "containers/LayoutV2";
import CustomerApi from "service/QuanLyKhachHang/DanhSachKhachHang/DanhSachKhachHangApi";
import CompanyApi from "service/danhSachCuaHangApi";
import NguonKhachHangApi from "service/nguonKhachHangApi";
import DoiTinhTrangNoApi from "service/doiTinhTrangNoApi";
import StoreApi from "service/phanQuyenApi";
import { SearchBarDestop } from "./SearchBarDestop";
import { TableDanhSach } from "./TableDanhSach";
import configsRole from "utils/configsRole";
import { ModalNguonKhachHang } from "../DanhSachKhachHang/NguonKhachHang/index";

export const DanhSachKhachHang1 = () => {
  const initPhanQuyen = {
    danhsachkhachhang: false,
    danhsachkhachhang_suakhachhang: false,
    danhsachkhachhang_nhapdanhsachkhachhangtufileexcel: false,
    danhsachkhachhang_xuatdanhsachkhachhangrafileexcel: false,
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);
  const [loading, setLoading] = useState(true);

  const [listCuaHang, setListCuaHang] = useState([]);
  const [listNguonKH, setListNguonKH] = useState([]);
  const [listTinhTrang, setListTinhTrang] = useState([]);

  const initialDataSearch = {
    keyword: "",
    loaiDoiTac: -1, // -1 = Tất cả
    tinhTrang: -1, // -1 = Tất cả
    trangThai: -1, // -1 = Tất cả
    nguonKHId: 0, // 0 = Tất cả
    DBName: null, // 0 = Tất cả
    pageIndex: 1,
    pageSize: 25,
  };
  const [dataSearch, setDataSearch] = useState(initialDataSearch);
  const [listDanhSach, setListDanhSach] = useState({ List: [], iTotal: 0 });
  const [isLoadingList, setIsLoadingList] = useState(false);
  const [showModalNguonKH, setShowModalNguonKH] = useState(false);

  const handleGetData = useCallback((searchParams) => {
    setIsLoadingList(true);
    const params = {
      ...searchParams,
      loaiDoiTac:
        searchParams.loaiDoiTac === -1 ? null : searchParams.loaiDoiTac,
      tinhTrang: searchParams.tinhTrang === -1 ? null : searchParams.tinhTrang,
      trangThai: searchParams.trangThai === -1 ? null : searchParams.trangThai,
      nguonKHId: searchParams.nguonKHId === 0 ? null : searchParams.nguonKHId,
    };
    CustomerApi.getList(params)
      .then((res) => {
        if (res.status === 200) {
          setListDanhSach({
            List: res.data.List || [],
            iTotal: res.data.iTotal || 0,
          });
        } else {
          setListDanhSach({ List: [], iTotal: 0 });
        }
      })
      .catch(() => setListDanhSach({ List: [], iTotal: 0 }))
      .finally(() => setIsLoadingList(false));
  }, []);

  const handleReloadList = useCallback(() => {
    handleGetData(dataSearch);
  }, [dataSearch]);

  const LoadData = useCallback(() => {
    Promise.all([
      StoreApi.getAllQuyen(),
      CompanyApi.getListCuaHang(),
      NguonKhachHangApi.getCombo(),
      DoiTinhTrangNoApi.getListTinhTrangNo(),
    ])
      .then(([resPQ, resCuaHang, resNguonKH, resTinhTrang]) => {
        if (resPQ.status === 200) {
          const getRole = (code) =>
            resPQ.data.some(
              (e) => e.ModuleCode?.toUpperCase() === code.toUpperCase()
            );
          setPhanQuyen({
            danhsachkhachhang: getRole(configsRole.sRole.danhsachkhachhang),
            danhsachkhachhang_suakhachhang: getRole(
              configsRole.sRole.danhsachkhachhang_suakhachhang
            ),
            danhsachkhachhang_nhapdanhsachkhachhangtufileexcel: getRole(
              configsRole.sRole
                .danhsachkhachhang_nhapdanhsachkhachhangtufileexcel
            ),
            danhsachkhachhang_xuatdanhsachkhachhangrafileexcel: getRole(
              configsRole.sRole
                .danhsachkhachhang_xuatdanhsachkhachhangrafileexcel
            ),
          });
        }
        if (resCuaHang.status === 200) {
          const transformedList = resCuaHang.data.map((item) => ({
            value: item.DbName,
            label: item.Name,
          }));
          setListCuaHang([
            { value: null, label: "Tất cả" },
            ...transformedList,
          ]);
        }
        if (resNguonKH.status === 200) {
          setListNguonKH(resNguonKH.data);
        }
        if (resTinhTrang.status === 200) {
          const transformedList = resTinhTrang.data.map((item) => ({
            value: item.Code,
            label: item.Name,
          }));

          setListTinhTrang([
            { value: -1, label: "Tất cả" },
            ...transformedList,
          ]);
        } else {
          setListTinhTrang([{ value: -1, label: "Tất cả" }]);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    document.title = "Danh sách khách hàng | Phần mềm Morman";
    LoadData();
  }, []);

  useEffect(() => {
    if (phanQuyen.danhsachkhachhang) {
      handleGetData(dataSearch);
    }
  }, [phanQuyen.danhsachkhachhang]);

  const handleReloadNguonKH = useCallback(() => {
    NguonKhachHangApi.getCombo()
      .then((res) => {
        if (res.status === 200) {
          setListNguonKH(res.data);
        }
      })
      .catch((err) => console.error("Tải lại nguồn KH thất bại", err));
  }, []);

  // if (loading) return null;

  return (
    <Layout>
      {phanQuyen.danhsachkhachhang ? (
        <div id="form-repeater" className="p-1">
          <div
            className="breadcrumb-new hidden-mobile-main mb-1"
            style={{ marginBottom: "5px" }}
          >
            <div className="row header justify-content-start">
              <img
                src="/app-assets/images/icon-danh-sach-khach-hang.png"
                alt="Khách hàng"
              />
              <h1 className="text-info-home">Danh sách khách hàng</h1>
            </div>
          </div>
          <div>
            <SearchBarDestop
              dataSearch={dataSearch}
              setDataSearch={setDataSearch}
              onSearch={handleGetData}
              listCuaHang={listCuaHang}
              listNguonKH={listNguonKH}
              listTinhTrang={listTinhTrang}
            />
            <div className="mb-1"></div>
            <TableDanhSach
              phanQuyen={phanQuyen}
              listDanhSach={listDanhSach}
              isLoading={isLoadingList}
              dataSearch={dataSearch}
              setDataSearch={setDataSearch}
              onReload={handleReloadList}
              onSearch={handleGetData}
              listTinhTrang={listTinhTrang}
              listCuaHang={listCuaHang}
              onOpenModalNguonKH={() => setShowModalNguonKH(true)}
            />
          </div>
        </div>
      ) : (
        <div className="p-1 text-center text-danger">
          Bạn không có quyền truy cập chức năng này.
        </div>
      )}
      {showModalNguonKH && (
        <ModalNguonKhachHang
          show={showModalNguonKH}
          onHide={() => {
            setShowModalNguonKH(false);
          }}
          onDataChanged={() => {
            handleReloadNguonKH();
          }}
          dbName={dataSearch.DBName}
        />
      )}
    </Layout>
  );
};
